var _jsxFileName = "/codebuild/output/src1397887924/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/CheckYourEmail/components/Content.tsx";
import React from 'react';
import { Button, Stack, Text } from '@adc/parallax-component-library';
import { RichText } from 'Components/utility';
import i18n from 'Utilities/i18n';
const Content = ({
  email,
  onButtonPress
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    testID: "CheckYourEmailRegistration.subtitle",
    text: i18n.t('CheckYourEmailRegistration.subtitle', {
      emailAddress: email
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('CheckYourEmailRegistration.content.checkYourEmail.media.checkYourEmail'),
    alt: "",
    style: {
      objectFit: 'contain',
      height: 205
    },
    id: "CheckYourEmailRegistration.check-email-img",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Stack, {
    gap: "$4",
    marginTop: "$3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "center",
    testID: "CheckYourEmailRegistration.primaryText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, i18n.t('CheckYourEmailRegistration.content.checkYourEmail.primaryText')), /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "row",
    justifyContent: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: i18n.t('CheckYourEmailRegistration.content.checkYourEmail.links.resendEmail.label'),
    "aria-label": i18n.t('CheckYourEmailRegistration.content.checkYourEmail.links.resendEmail.label'),
    onPress: onButtonPress,
    testID: "CheckYourEmailRegistration.resendEmail-btn",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }))));
};
export default Content;